var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "panel-tag" }, [
        _vm._v("\n        " + _vm._s(_vm.__t("DB_PARAMS")) + "\n    "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.cur_db, function (key_val, key_name) {
        return key_name.length > 0 && key_name != "id"
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t(key_name.toUpperCase())) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-group input-group-lg bg-white shadow-inset-2 with_icon",
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("b-form-input", {
                    key: key_name,
                    staticClass: "form-control bg-transparent pl-5",
                    attrs: {
                      debounce: "300",
                      state: _vm.is_valid_key(_vm.cur_db[key_name]),
                      id: "db_pos_param_" + key_name,
                    },
                    on: {
                      update: function ($event) {
                        return _vm.on_change_value(key_name)
                      },
                    },
                    model: {
                      value: _vm.cur_db[key_name],
                      callback: function ($$v) {
                        _vm.$set(_vm.cur_db, key_name, $$v)
                      },
                      expression: "cur_db[key_name]",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass:
            "input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3",
        },
        [
          _c("span", { staticClass: "icon-stack fs-xxl" }, [
            _c("i", { staticClass: "base-7 icon-stack-3x color-primary-500" }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fal fa-database icon-stack-1x text-white",
            }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }